import { CommonModule } from '@angular/common';
import { Component, ViewChild, ElementRef } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { fromEvent } from 'rxjs';

import { AppProgressBarService } from './app-progressbar.service';
import { GoogleAnalytiscService } from './google-Analytics.service';
import { PrintReceiptComponent } from './shared/components/print-receipt/print-receipt.component';
import { LoaderService } from './shared/service/loader.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterOutlet, MatProgressBarModule, PrintReceiptComponent, TranslocoModule],
})
export class AppComponent {
    @ViewChild('progressBar', { static: true }) progressBar: ElementRef;

    isConnected = false;
    constructor(
        private progressBarSerivce: AppProgressBarService,
        public loaderService: LoaderService,
        private googleAnalytiscService: GoogleAnalytiscService
    ) {
        this.progressBarSerivce.get().subscribe((resp) => {
            this.progressBar.nativeElement.style.display = resp ? 'block' : 'none';
        });

        fromEvent(window, 'online').subscribe(() => {
            this.isConnected = false;
        });

        fromEvent(window, 'offline').subscribe(() => {
            this.isConnected = true;
        });
    }
}
